import { render, staticRenderFns } from "./CustomersAddPage.vue?vue&type=template&id=fd95e424&scoped=true"
import script from "./CustomersAddPage.vue?vue&type=script&lang=js"
export * from "./CustomersAddPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd95e424",
  null
  
)

export default component.exports